export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-31.035e0d97.jpg";